import api from './api';

export interface GeneralInfo {
    id: string;
    logo: string | null;
    phone: string | null;
    emailcontact: string | null;
    emailadhesion: string | null;
    emailtraining: string | null;
    address: string | null;
    rib: string | null;
    createdAt: string;
    updatedAt: string;
}

export const generalInfoService = {
    getGeneralInfo: async (): Promise<GeneralInfo> => {
        const response = await api.get('/general-info');
        return response.data;
    },
};
